import React from 'react';

import useTranslation from '../../hooks/use_translation';
import BadgeCampaign from '../framework/badges/badge-campaign';
import Trans from '../translation/trans';

const CampaignProduct = () => {
	const { t } = useTranslation('component_campaign_product');

	return (
		<div className="bg-gray-100 rounded-3 text-dark p-3 d-flex align-items-center">
			<BadgeCampaign />
			<div>
				<h3 className="xs fw-700 text-uppercase">{t('t1')}</h3>
				<p className="xs mb-0">
					<Trans i18nKey="t2" t={t} />
				</p>
			</div>
		</div>
	);
};

export default CampaignProduct;
